module.exports = __webpack_public_path__ + "static/media/info-icon.46cdf4f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/info-icon.svg
// module id = 240
// module chunks = 7